import React, { ReactElement } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import ListMenu from "./Menu";

export type listItemMenu = {
  icons?: Array<ReactElement>;
  label: string;
  onClick?: () => void;
  checked?: boolean;
  redirectTo?: { pathname: string; state: { [key: string]: string } };
};

const IconButtonMenu = ({
  icon = <MoreVertIcon />,
  listItemMenu,
  className,
}: {
  icon?: ReactElement;
  listItemMenu?: Array<listItemMenu>;
  className?: string;
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        className={className}
        style={{ zIndex: 100 }}
        disableRipple
        disableFocusRipple
        disableTouchRipple
      >
        {icon}
      </IconButton>
      <ListMenu
        listItemMenu={listItemMenu}
        anchorEl={anchorEl}
        onRemoveAnchorEl={handleClose}
      />
    </div>
  );
};

export default IconButtonMenu;
